import React from 'react';
import './TituloConFondo.css'; // Archivo CSS para los estilos

const TituloConFondo = ({ titulo }) => {
  return (
    <div
      className="fondo-imagen colorcalido"
    >
      <div className="contenedor-titulo">
        <h1 className="titulo">{titulo}</h1>
      </div>
    </div>
  );
};

export default TituloConFondo;